import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { RequiredLabel } from './RequiredLabel';

export const emptyRestaurantForm = () => ({
  name: '', address: '', contact_person: '', phone: '', email: '',
  hr_email: '', phone_2: '', cuisine_type: '', capacity: '', available_positions: '', notes: '',
});

export const restaurantToForm = (r) => ({
  name: r.name || '', address: r.address || '', contact_person: r.contact_person || '', phone: r.phone || '',
  email: r.email || '', hr_email: r.hr_email || '', phone_2: r.phone_2 || '', cuisine_type: r.cuisine_type || '',
  capacity: String(r.capacity ?? ''), available_positions: String(r.available_positions ?? ''), notes: r.notes || '',
});

export const formToPayload = (f) => ({
  ...f,
  capacity: parseInt(f.capacity) || 0,
  available_positions: parseInt(f.available_positions) || 0,
});

export const RestaurantForm = ({ formData, setFormData, disabled = false }) => {
  const set = (k) => (e) => setFormData({ ...formData, [k]: e.target.value });
  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="col-span-2">
        <RequiredLabel>Restaurant Name</RequiredLabel>
        <Input data-testid="restaurant-name" value={formData.name} onChange={set('name')} disabled={disabled} required />
      </div>
      <div className="col-span-2">
        <RequiredLabel>Address</RequiredLabel>
        <Input data-testid="restaurant-address" value={formData.address} onChange={set('address')} disabled={disabled} required />
      </div>
      <div>
        <RequiredLabel>Contact Person</RequiredLabel>
        <Input data-testid="restaurant-contact" value={formData.contact_person} onChange={set('contact_person')} disabled={disabled} required />
      </div>
      <div>
        <RequiredLabel>Phone</RequiredLabel>
        <Input data-testid="restaurant-phone" value={formData.phone} onChange={set('phone')} disabled={disabled} required />
      </div>
      <div>
        <Label>Email</Label>
        <Input data-testid="restaurant-email" type="email" value={formData.email} onChange={set('email')} disabled={disabled} placeholder="Optional — required when sending contracts" />
      </div>
      <div>
        <Label>HR Email</Label>
        <Input data-testid="restaurant-hr-email" type="email" value={formData.hr_email} onChange={set('hr_email')} disabled={disabled} placeholder="Optional — shown on Student Placement Letter" />
      </div>
      <div>
        <Label>Alt Phone (Tel 2)</Label>
        <Input data-testid="restaurant-phone-2" value={formData.phone_2} onChange={set('phone_2')} disabled={disabled} placeholder="Optional — shown on Student Placement Letter" />
      </div>
      <div>
        <RequiredLabel>Cuisine Type</RequiredLabel>
        <Input data-testid="restaurant-cuisine" value={formData.cuisine_type} onChange={set('cuisine_type')} disabled={disabled} placeholder="e.g., French, Italian" required />
      </div>
      <div>
        <Label>Capacity</Label>
        <Input data-testid="restaurant-capacity" type="number" value={formData.capacity} onChange={set('capacity')} disabled={disabled} />
      </div>
      <div>
        <RequiredLabel>Available Positions</RequiredLabel>
        <Input data-testid="restaurant-positions" type="number" value={formData.available_positions} onChange={set('available_positions')} disabled={disabled} required />
        <p className="text-[10px] text-gray-500 mt-1">Seats offered per placement cycle.</p>
      </div>
      <div className="col-span-2">
        <Label>Notes</Label>
        <Textarea data-testid="restaurant-notes" value={formData.notes} onChange={set('notes')} disabled={disabled} rows={3} />
      </div>
    </div>
  );
};
